/* eslint-disable react-refresh/only-export-components */

import { NoiseMonitoringMovedNode } from "src/components/Devices/DeviceSettings/DeviceSettingsNodes"
import { EditType } from "src/data/editField/editFieldTypes"
import { langKeys } from "src/i18n/langKeys"

import { Section } from "./types/deviceSettingTypes"

export const NOISE_MONITORING_SECTION_KEY = "noise monitoring settings"

export const SectionNoiseMonitoring: Section = {
  type: EditType.SECTION,
  key: NOISE_MONITORING_SECTION_KEY,
  title: langKeys.sound_noise_monitoring,
  description: "",
  info: "",
  contents: [NoiseMonitoringMovedNode],
}
